import script from "./ViewInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewInvoice.vue?vue&type=script&setup=true&lang=js"

import "./ViewInvoice.vue?vue&type=style&index=0&id=1ccf9567&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ccf9567"]])

export default __exports__